"use client";

const STORAGE_KEY = "mfa_challenge";

export interface MfaChallengeData {
  pending_authentication_token: string;
  authentication_challenge_id: string;
}

export function setMfaChallenge(data: MfaChallengeData): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getMfaChallenge(): MfaChallengeData | null {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as MfaChallengeData;
  } catch {
    return null;
  }
}

export function clearMfaChallenge(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY);
}
